// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1PgpX","title":"Header_title__3c9pR","side":"Header_side__1U0cZ"};